import Vue from 'vue'
import vuex from 'vuex'
Vue.use(vuex);

export default new vuex.Store({
    state: {
        updateOperationLogTable: '',
        routerData: [{ name: '安全设置', url: '/securitySetting' }],
        currentUser: null,
        overdue: null,
        resetSuccess: false,
    },
    mutations: {
        updateOperationLogTable(state, value) {
            state.updateOperationLogTable = value;
        },
        routerData(state, value) {
            state.routerData = value;
        },
        saveCurrentUser(state, value){
            state.currentUser = value;
        },
        // 是否过期状态
        saveOverdue(state, value){
            state.overdue = value;
        },
        // 密码修改成功状态
        changeResetSuccess(state, value){
            state.resetSuccess = value;
        },
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js